export const ID = 0;
export const NAME = 1;
export const TOTAL = 2;
export const COMMENTS = 3;
export const MESSAGES = 4;
export const MESSAGE_POINTS = 5;
export const RECENT_COMMENTS = 6;
export const DISCUSSIONS = 7;
export const MENTIONS = 8;
export const CHANGE_POINTS = 9;
export const LIVE_COMMENTS = 10;
export const SPINS = 11;